// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__T0J-k","NavigationItems":"Menu_NavigationItems__1TsoI","Open":"Menu_Open__1xWRC","Close":"Menu_Close__2FUOI","Hide":"Menu_Hide__3qa3Y","Show":"Menu_Show__3ZgBA"};